import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import ProgramDetail from "@/pages/ProgramDetail";
import Certifications from "@/pages/Certifications";
import Resources from "@/pages/Resources";
import News from "@/pages/News";
import Contact from "@/pages/Contact";
import BecomeInstructor from "@/pages/BecomeInstructor";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Course from "@/pages/Course";
import Exam from "@/pages/Exam";
import Result from "@/pages/Result";
import AuthCallback from "@/pages/AuthCallback";
import Verify from "@/pages/Verify";
import Direct from "@/pages/Direct";
import Admin from "@/pages/Admin";
import Corporate from "@/pages/Corporate";
import Claim from "@/pages/Claim";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ProtectedRoute from "@/components/ProtectedRoute";
import AITutor from "@/components/AITutor";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback (session_id in URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <Routes>
        {/* NEW DOOSP marketing site */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/programs/:slug" element={<ProgramDetail />} />
        <Route path="/certifications" element={<Certifications />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/become-instructor" element={<BecomeInstructor />} />
        {/* Legal */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        {/* Legacy BBP landing preserved */}
        <Route path="/bbp" element={<Landing />} />

        {/* EXISTING routes — 100% preserved */}
        <Route path="/verify" element={<Verify />} />
        <Route path="/verify/:certId" element={<Verify />} />
        <Route path="/corporate" element={<Corporate />} />
        <Route path="/corporate/order/:orderRef" element={<Corporate />} />
        <Route path="/claim/:token" element={<Claim />} />
        <Route path="/direct" element={<Direct />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/course"
          element={
            <ProtectedRoute>
              <Course />
            </ProtectedRoute>
          }
        />
        <Route
          path="/course/:slug"
          element={
            <ProtectedRoute>
              <Course />
            </ProtectedRoute>
          }
        />
        <Route
          path="/exam"
          element={
            <ProtectedRoute>
              <Exam />
            </ProtectedRoute>
          }
        />
        <Route
          path="/result/:attemptId"
          element={
            <ProtectedRoute>
              <Result />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
      </Routes>
      <AITutor />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
